module.exports = __webpack_public_path__ + "static/media/1-2-2.ea658b96.png";